import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    sportRevenueCodeList: [],
    sportRevenueCodeListLoading: false,
    trackingCategoriesList: [],
    trackingCategoriesListLoading: false,
    trackingOptionsList: [],
    trackingOptionsListLoading: false,
    invoiceObjects: [],
    invoiceObjectsLoading: false
  },
  mutations: {
    setSportRevenueCodeList(state, payload) {
      state.sportRevenueCodeList = payload;
    },
    setSportRevenueCodeListLoading(state, payload) {
      state.sportRevenueCodeListLoading = payload;
    },
    setTrackingCategoriesList(state, payload) {
      state.trackingCategoriesList = payload;
    },
    setTrackingCategoriesListLoading(state, payload) {
      state.trackingCategoriesListLoading = payload;
    },
    setTrackingOptionsList(state, payload) {
      state.trackingOptionsList = payload;
    },
    setTrackingOptionsListLoading(state, payload) {
      state.trackingOptionsListLoading = payload;
    },
    setInvoiceObjects(state, payload) {
      state.invoiceObjects = payload;
    },
    setInvoiceObjectsLoading(state, payload) {
      state.invoiceObjectsLoading = payload;
    }
  },
  actions: {
    async loadAllSportRevenueCodes({ commit }) {
      commit("setSportRevenueCodeListLoading", true);
      let list = await api.get("xero/settings/sportRevenueCodes");
      commit("setSportRevenueCodeList", list.data);
      commit("setSportRevenueCodeListLoading", false);
    },
    async loadAllTrackingCategories({ commit }) {
      commit("setTrackingCategoriesListLoading", true);
      let list = await api.get("xero/settings/trackingCategories");
      commit("setTrackingCategoriesList", list.data);
      commit("setTrackingCategoriesListLoading", false);
    },
    async loadAllTrackingOptions({ commit }) {
      commit("setTrackingOptionsListLoading", true);
      let list = await api.get("xero/settings/trackingOptions");
      commit("setTrackingOptionsList", list.data);
      commit("setTrackingOptionsListLoading", false);
    },
    async loadAllInvoiceObjects({ commit }, competitions_id) {
      commit("setInvoiceObjectsLoading", true);
      let list = await api.get("competition/invoiceBuilder", {
        params: { competitions_id: competitions_id }
      });
      commit("setInvoiceObjects", list.data);
      commit("setInvoiceObjectsLoading", false);
    }
  },
  getters: {
    sportRevenueCodeList(state) {
      return state.sportRevenueCodeList;
    },
    sportRevenueCodeListLoading(state) {
      return state.sportRevenueCodeListLoading;
    },
    trackingCategoriesList(state) {
      return state.trackingCategoriesList;
    },
    trackingCategoriesListLoading(state) {
      return state.trackingCategoriesListLoading;
    },
    trackingOptionsList(state) {
      return state.trackingOptionsList;
    },
    trackingOptionsListLoading(state) {
      return state.trackingOptionsListLoading;
    },
    invoiceObjects(state) {
      return state.invoiceObjects;
    },
    invoiceObjectsLoading(state) {
      return state.invoiceObjectsLoading;
    }
  }
};
